module.exports = __webpack_public_path__ + "static/media/doom.8f763caf.jpeg";